import React, { Suspense } from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";

import "us.style/antd.less";
import "us.style/index.scss";
import "us.helper/utility/dayjsConfig";
import { Loader } from "us.common/components";

import App from "App";
import * as serviceWorker from "serviceWorker";
import store from "store";
import * as Azure from "us.helper/azure";
import {
  PublicClientApplication,
  EventType,
  EventMessage,
  AuthenticationResult,
} from "@azure/msal-browser";
import { setupTitle } from "us.helper";
import { MsalProvider } from "@azure/msal-react";

window.APP_MODULE = "io";

export const msalInstance = new PublicClientApplication(Azure.msalConfig);

msalInstance.initialize().then(() => {
  // Account selection logic is app dependent. Adjust as needed for different use cases.
  const accounts = msalInstance.getAllAccounts();
  if (accounts.length > 0) {
    msalInstance.setActiveAccount(accounts[0]);
  }

  // Optional - This will update account state if a user signs in from another tab or window
  msalInstance.enableAccountStorageEvents();

  msalInstance.addEventCallback((event: EventMessage) => {
    if (event.eventType === EventType.LOGIN_SUCCESS && event.payload) {
      const payload = event.payload as AuthenticationResult;
      const account = payload.account;
      msalInstance.setActiveAccount(account);
    } else if (event.eventType === EventType.LOGOUT_SUCCESS) {
      msalInstance.setActiveAccount(null);
      window.location.reload(); // Optional: force UI update
    } else if (event.eventType === EventType.ACCOUNT_ADDED && event.payload) {
      const payload = event.payload as AuthenticationResult;
      const account = payload.account;
      msalInstance.setActiveAccount(account);
    } else if (event.eventType === EventType.ACCOUNT_REMOVED) {
      msalInstance.setActiveAccount(null);
      window.location.reload(); // Optional: force UI update
    }
  });

  //set the dynamic title
  setupTitle();

  const rootElement = document.getElementById("root");
  if (rootElement) {
    const root = createRoot(rootElement);
    root.render(
      <Provider store={store}>
        <MsalProvider instance={msalInstance}>
          <Suspense fallback={<Loader />}>
            <App />
          </Suspense>
        </MsalProvider>
      </Provider>
    );
  }

  // If you want your app to work offline and load faster, you can change
  // unregister() to register() below. Note this comes with some pitfalls.
  // Learn more about service workers: https://bit.ly/CRA-PWA
  serviceWorker.unregister();
});
